import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.css';

class OrganizationNameRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      data, disabled, detailUrl,
    } = this.props;
    if (!data) {
      return null;
    }
    const org = data.organization || data;

    const displayName = org.display_name || org.name;
    const realName = org.name;
    const nameDifferent = displayName !== realName && realName !== undefined;
    const subname = nameDifferent ? (<span className="text-muted">({realName})</span>) : null;
    const isDemo = org.is_demo;
    const demoBadge = isDemo ? (<span className="badge badge-warning">DEMO</span>) : null;
    const nameWithoutParenthesses = displayName.replace(/\(([^\)]+)\)$/igm, '');
    const avatar = (<span className={styles.orgPhoto}><UserAvatar borderRadius="2px" name={nameWithoutParenthesses} size="24" /></span>);
    const active = org.enabled === true;
    const tip = (
      <Tooltip id={`client-status-${org._id}`}>
        <div>{active ? 'Active Client' : 'Inactive Client'}</div>
      </Tooltip>
    );
    
    const activeComp = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
        <Fa name="circle" className={active ? 'text-success' : 'text-danger'} />
      </OverlayTrigger>
    );

    if (isDemo || !detailUrl) {
      return <span>{activeComp} {avatar} {displayName} {subname} {demoBadge}</span>;
    }
    return (
      <span>
        {activeComp}&nbsp; {avatar} <Link disabled={disabled} to={`${detailUrl}${org._id}`}><span className={active ? '' : 'text-muted'}>{displayName}</span></Link> {subname} {demoBadge}
      </span>
    );
  }
}

OrganizationNameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  detailUrl: PropTypes.string,
};
OrganizationNameRenderer.defaultProps = {
  value: null,
  data: null,
  disabled: false,
  detailUrl: null,
};

export default OrganizationNameRenderer;
